module.exports = __webpack_public_path__ + "img/artist5.b2efaa00.jpg";